<div class="relative w-full h-full">
  <canvas #chartCanvas class="dimot-chart-main"></canvas>

  <div *ngIf="!hasData" class="absolute inset-0 flex items-center justify-center pointer-events-none">
    <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm mb-5">Non ci sono dati da mostrare</p>
  </div>
</div>

<app-modal-open-to-market-curve-30-days
  *ngIf="isMarketCurveOpen"
  [curvePointData]="curvePointData"
  [widgetTitle]="widgetTitle"
  (isModalOpen)="onOpenMarketCurveFromWidget($event)"
></app-modal-open-to-market-curve-30-days>